module.exports = __webpack_public_path__ + "static/logo-3d7dde998d96535bf8b5966f48a91bbf.png";